export default {
  login: {
    welcomeMsg: "Bienvenue ! Connexion",
    info: "Entrez vos identifiants.",
    forgot: "Mot de passe oublié ?",
    btn: "Connexion",
    unableToLogin: "Impossible de se connecter",
  },
  
  forgot: {
    info_l1:
      "Veuillez entrer l'adresse e-mail associée à votre compte. Les détails du mot de passe seront envoyés à votre adresse e-mail/mobile.",
    info_l2:
      "Veuillez entrer votre numéro de mobile associé à votre compte. Les détails du mot de passe seront envoyés à votre numéro de téléphone.",
    info_l3:
      "Veuillez choisir l'une des options suivantes pour recevoir les instructions sur la réinitialisation de votre mot de passe",
    forgotQ: "Mot de passe oublié ?",
    loginNow: "Connectez-vous maintenant",
    resetSucc: "Votre mot de passe a été réinitialisé avec succès",
    resetSucc_l2:
      "Vous pouvez maintenant utiliser votre nouveau mot de passe pour vous connecter à votre compte.",
    entPsw: "Veuillez entrer votre nouveau mot de passe.",
    resetPsw: "Réinitialisez votre mot de passe",
    resendOTP: "Renvoyer le code OTP",
    enterCorrectOTP: "Veuillez entrer le code OTP correct.",
    enterOTP: "Veuillez entrer le code OTP reçu par e-mail/mobile.",
    backToLoginPage: "Retour à la page de connexion",
    recieveCodeFalse: "Je n'ai pas reçu le code",
  },
  
  permissions: {
    savePermissions: "ENREGISTRER LES AUTORISATIONS",
    moduleName: "Nom du module",
    view: "Voir",
    create: "Créer",
    update: "Mettre à jour",
    delete: "Supprimer",
    permissionsUpdated: "Autorisations mises à jour",
    permissionsNotUpdated: "Autorisations non mises à jour",
    selectMembership: "Sélectionner un abonnement",
    noPermMsg:
      "Veuillez sélectionner le type d'abonnement en utilisant le menu déroulant 'Type d'abonnement' ci-dessus pour voir vos autorisations",
    selectRoleMsg: "Veuillez sélectionner le rôle ci-dessus pour afficher les autorisations",
  },
  

  activationKey: {
    logs: {
      time: "Heure",
      username: "Nom d'utilisateur",
      role: "Rôle",
      terminalID: "ID du terminal",
      moduleAccessed: "Module Accédé",
      typeOfAccess: "Type d'accès",
      activityLogDetails: "Détails du journal d'activité",
      userId: "ID utilisateur",
      lastLogin: "Dernière connexion",
      geoAccPoint: "Point d'accès géographique",
      ipAdd: "Adresse IP",
      filesAccessed: "Fichiers accédés",
      funAccessed: "Fonction accédée",
      webUrl: "URL de la page Web",
      unsuccAtmp: "Tentative de connexion échouée",
      view: "Voir",
      membershipType: "Type d'abonnement",
    },
    memberDataSection: {
      import: "Importer",
      buyingStation: "Station d'achat",
      continue: "Continuer",
      farmerId: "ID Agriculteur",
      farmerName: "Nom de l'agriculteur",
      farmerAddress: "Adresse de l'agriculteur",
      quality: "Qualité",
      quantity: "Quantité",
      importAll: "Tout importer",
      importSelected: "Importer la sélection",
      fileLoaded: "Fichier chargé avec succès",
      incorrectHeaders: "En-têtes incorrects",
      processingBatch: "Traitement du lot",
      purchaseOrder: "Bon de commande",
      startDate: "Date de début",
      endDate: "Date de fin",
      purchasingOrder: "Commande d'achat",
      totalCoffeeCherry: "Total des cerises de café",
      airHumidity: "Humidité de l'air",
      density: "Densité",
      temperature: "Température",
      beanMoistureContent: "Teneur en humidité des grains",
      processType: "Type de processus",
      batchRating: "Sélectionner l'évaluation du lot",
      purchaseDate: "Date d'achat",
      selectFarmer: "Sélectionner l'agriculteur",
      selectFarmers: "Sélectionner les agriculteurs",
      selectFarm: "Sélectionner la ferme",
      selectPlantation: "Sélectionner la plantation",
      coffeeVariety: "Variété de café",
      coffeeSpecies: "Espèce de café",
      coffeeCherryQuantity: "Quantité de cerises de café",
      coffeeCherryQuality: "Qualité des cerises de café",
      coffeeType: "Type de café",
      pricePerKg: "Prix par kg",
      processingDone: "Traitement terminé",
      processedCoffeeOut: "Café traité sorti",
      farmer: "Agriculteur",
      farm: "Ferme",
      plantation: "Plantation",
      farmers: "Agriculteurs",
      farmLimitUsed: "Limite de ferme utilisée",
      phoneNumber: "Numéro de téléphone",
      farmSize: "Taille de la ferme",
      farmLocation: "Ferme/Localisation",
      date: "Date",
      status: "Statut",
      noFarmers: "Aucun agriculteur trouvé",
      approveReject: "Approuver/Rejeter",
      farms: "Fermes",
      crops: "Cultures",
      equipment: "Équipement",
      noFarms: "Aucune ferme trouvée",
      views: "Voir",
      selectStatus: "Sélectionner le statut",
      approved: "Approuvé",
      rejected: "Rejeté",
      reject: "Rejeter",
      approve: "Approuver",
      cancel: "Annuler",
      add: "Ajouter",
      describeYourReason: "Décrivez votre raison ici",
      userInformation: "Informations utilisateur",
      userFarmRequest: "Demande de ferme utilisateur",
      userFarmInformation: "Informations de la/des ferme(s) utilisateur",
      activity: "Activité",
      activityType: "Type d'activité",
      farmZone: "Zone de la ferme",
      farmerView: "Vue de l'agriculteur",
      cropType: "Type de culture",
      cropVarity: "Variété de culture",
      area: "Surface",
      cost: "Coût",
      geofence: "Clôture géographique",
      map_views: "Vue de la carte",
      viewAllFarms: "Voir toutes les fermes",
      farmersDetails: "Détails de l'agriculteur",
      download: "Télécharger",
      pOrder: {
        addNew: "Ajouter nouveau",
        viewAll: "Voir tout",
        selectDate: "Sélectionner une date",
        makeSelection: "Faire une sélection",
        coffeeType: "Saisir la quantité de café",
        enterPrice: "Saisir le prix",
        reqPurchaseDate: "La date d'achat est requise",
        reqFarmer: "L'agriculteur est requis",
        reqCoffeeQnty: "La quantité de cerises de café est requise",
        reqPrice: "Le prix par kg est requis",
        grandTotal: "TOTAL GÉNÉRAL",
        selectDateRange: "Sélectionner une plage de dates",
        import: "Importer",
        purchaseId: "ID d'achat",
        purchaseDate: "Date d'achat",
        farmerName: "Nom de l'agriculteur",
        quality: "Qualité",
        quantity: "Quantité",
        pricePerKg: "Prix par kg",
        selectBuyingStation: "Sélectionner la station d'achat",
        searchUser: "Rechercher des utilisateurs",
        purchaseListView: "Vue de la liste d'achat",
        viewBy: "Voir par",
        typeDensity: "Saisir la densité",
        typeTemperature: "Saisir la température",
        typeWaterContent: "Saisir la teneur en eau",
      },
      farmActivity: "Activité agricole",
      showOnMap: "Afficher sur la carte",
      farmInformation: "Informations de la ferme",
      dateOfEntry: "Date d'entrée",
      farmID: "ID de la ferme",
      ownershipType: "Type de propriété",
      locationAddress: "Adresse de localisation",
      goalType: "Type d'objectif",
      totalSize: "Taille totale",
      zones: "Zones",
      farmActivities: "Activités de la ferme",
      farmDetails: "Détails de la ferme",
      totalFarmsRegistered: "Nombre total de fermes enregistrées",
      totalFarmArea: "Superficie totale des fermes",
      totalZone: "Nombre total de zones",
      zone: "Zone",
      totalCost: "Coût total",
      selectFarmZone: "Sélectionner une zone/ferme",
      productionType: "Type de production",
      certifications: "Certifications",
      geofences: "Clôtures géographiques",
      farmsChart: "Graphique des fermes",
    },
    enterActivationKey: "Veuillez entrer la clé d'activation pour enregistrer un nouvel utilisateur",
    mitigation: "Atténuation manuelle des risques",
    countryRequired: "Le pays est requis",
    activationKeyRequired: "La clé d'activation est requise",
    activationKey: "Clé d'activation",
    activationKeyLimit: "Clé d'activation trop courte",
    membershipRoleFilterDesc: "Filtrer le plan d'adhésion par rôle",
    email: "Email",
    filterBy: "Filtrer par",
    membershipRoleFilter: "Filtre de rôle d'adhésion",
    appointSalesManager: "Nommer un responsable des ventes",
    appointManager: "NOMMER UN RESPONSABLE",
    salesManAppSuccess: "RESPONSABLE DES VENTES NOMMÉ AVEC SUCCÈS",
    uploadData: "TÉLÉCHARGER LES DONNÉES ATTRIBUÉES CSV",
    uploadUserData: "Veuillez télécharger le fichier de données utilisateur",
    downloadCsv: "Télécharger le fichier .csv d'exemple pour suivre la structure",
    downloadSample: "Télécharger le fichier d'exemple",
    dragDrop: "Glisser-déposer ou",
    browse: "parcourir",
    yourFile: "votre fichier",
    pdfSupport: "Seuls les fichiers PDF sont pris en charge.",
    pleaseWait: "Veuillez patienter",
    note: "Remarque",
    incorectFileType: "Type de fichier incorrect",
    somethingWentWrong: "Quelque chose s'est mal passé",
    fileUploadedSuccess: "Fichier téléchargé avec succès",
    countRecords: "Compter les enregistrements",
    sendNow: "ENVOYER MAINTENANT",
    fileName: "nom du fichier",
    assignActKey: "Attribuer des clés d'activation",
    actKeyAssSucc: "Clés d'activation attribuées avec succès",
    viewActKey: "VOIR LES CLÉS D'ACTIVATION",
    actKeyQuota: "Quota de clés d'activation",
    genActKey: "Clés d'activation générées",
    remActKey: "Clés d'activation restantes",
    penUsed: "Clés en attente et utilisées",
    activationKeyAss: "Clés d'activation attribuées",
    activationKeyUnass: "Clés d'activation non attribuées",
    keysAct: "Clés activées",
    uploadedFiles: "Fichiers téléchargés",
    generateActKey: "GÉNÉRER DES CLÉS D'ACTIVATION",
    showData: "Afficher les données",
    noDataFound: "Aucune donnée trouvée",
    pleaseGenKey: `Veuillez générer les clés d'activation en utilisant le bouton "Générer des clés d'activation"`,
    noActKey: "Aucune clé d'activation générée pour le moment",
    buttonAbv: "bouton ci-dessus",
    numberOfActKey: "Nombre de clés d'activation",
    membershipRole: "Rôle d'adhésion",
    membershipPlan: "Plan d'adhésion",
    comments: "Commentaires",
    genKeys: "GÉNÉRER DES CLÉS",
    keysNum: "Nombre de clés",
    phoneNumber: "Numéro de téléphone",
    keysStatus: "Statut des clés",
    ActivationKeysList: "Liste des clés d'activation",
    back: "RETOUR",
    usingActKeys: `en utilisant le bouton "Générer des clés d'activation"`,
    pleaseGenActKeyss: `Veuillez générer les clés d'activation`,
    clearAllFilters: "EFFACER TOUS LES FILTRES",
    salesManager: "Responsable des ventes",
    clearAll: "TOUT EFFACER",
    generatedBy: "Généré par",
    numberOfKeys: "Nombre de clés",
    action: "Action",
    viewAllUplFiles: "VOIR TOUS LES FICHIERS TÉLÉCHARGÉS",
    bulkUploadUsers: "TÉLÉCHARGEMENT EN MASSE DES UTILISATEURS",
    noActivationKeyFound: "Aucune clé d'activation trouvée",
    pleaseCreateAdminRole: "Veuillez créer un rôle d'administrateur en utilisant le",
    btnCreateAdmin: "bouton 'Créer un rôle d'administrateur' ci-dessus",
    donwloadAsCsv: "Télécharger en CSV",
    donwloadAsPdf: "Télécharger en PDF",
    assignSalesManager: "Attribuer un responsable des ventes",
    shareViaEmail: "Partager par email",
    memberRequired: "L'adhésion est requise",
    memberRoleRequired: "Le rôle d'adhésion est requis",
    memberKeyRequired: "La valeur de la clé est requise",
    enterComment: "Entrez votre commentaire ici",
    sendEmail: "ENVOYER EMAIL",
    emailSend: "EMAIL ENVOYÉ AVEC SUCCÈS",
    donwload: "Télécharger",
    deleteFile: "Supprimer le fichier",
    invalidFileData: "Les données de clé d'activation, d'email et de numéro de téléphone dans le fichier sont invalides",
  },

  profileSetting: {
    defaultOrganizationOTPForSignUp: "OTP d'organisation par défaut pour l'inscription",
    whoreceivedthealert: "Qui reçoit l'alerte",
    otp: "OTP",
    passwordReuse: "Réutilisation du mot de passe",
    organizationSplashScreen: "Écran de démarrage de l'organisation",
    organizationSplash1: "Écran d'accueil de l'organisation",
    generateOtp: "Générer OTP",
    addAnother: "Ajouter un autre",
    dragAndDropOr: "Glisser-déposer ou Parcourir",
    browse: "Parcourir",
    save: "Enregistrer",

    profileAuthSettings: "Paramètres d'authentification du profil",
    changeSettings: "MODIFIER LES PARAMÈTRES",
    loginLogoutSettings: "Paramètres de connexion/déconnexion",
    autoLogout: "Déconnexion automatique",
    unsuccAtmp: "Tentatives de connexion échouées",
    unsuccLoginLock: "Période de verrouillage après échecs de connexion",
    pswCrisetup: "Configuration des critères de mot de passe",
    pswLength: "Longueur du mot de passe",
    noOfUniquePsw: "Nombre de mots de passe uniques requis",
    maxPswAge: "Âge maximal du mot de passe",
    AccRangeOfchars: "Plage de caractères acceptables",
    upperCase: "Majuscules",
    lowerCase: "Minuscules",
    numbers: "Chiffres",
    specialChars: "Caractères spéciaux",
    settingsUpdated: "Paramètres mis à jour",
    settingsNotUpdated: "Paramètres non mis à jour",
    organization: "Organisation",
    organizationLogo: "Logo de l'organisation",
    organizationSplash: "Écran d'accueil de l'organisation",
    cropsHarvestAlert: "Alertes de récolte des cultures",
    alertCrop: "Culture",
    alertCropInfo: "Culture pour laquelle vous recevrez une alerte",
    alertCountry: "Pays",
    alertCountryInfo: "Pays pour lequel vous recevrez une alerte",
    alertRegion: "Région",
    alertRegionInfo: "Région du pays sélectionné pour laquelle vous recevrez une alerte",
    alertMaximum: "Quantité maximale",
    alertMaximumInfo: "Quantité maximale autorisée après laquelle vous recevrez une alerte",
    selectCrop: "Sélectionner une culture",
    alertFor: "Sélectionner qui reçoit l'alerte",
    alertAdmin: "Alerte administrateur",
    alertFarmer: "Alerte agriculteur",
    selectCountry: "Sélectionner un pays",
    selectCountryInfo: "Choisissez l'emplacement géographique applicable à l'évaluation.",
    maxProduction: "Production maximale / Hectares / An",
    maxAllowed: "Max autorisé / Ha / An",
    alert: "Alerte",
    defaultOtpOrganization: "OTP par défaut pour l'organisation à l'inscription",
    crop: "Culture",
    maxProductionError: "La production maximale doit être saisie",
    selectCountryError: "Veuillez sélectionner un pays d'abord",
    selectCropError: "Veuillez sélectionner une culture d'abord",
    unitError: "Veuillez définir la production maximale et l'unité",
    per_hour: "Par heure",
    per_day: "Par jour",
    per_minute: "Par minute",
    per_week: "Par semaine",
    per_month: "Par mois",
    per_year: "Par an",
    per_second: "Par seconde",
    per_session: "Par session",
    per_login: "Par connexion",
    mins: "Minutes",
    hours: "Heures",
    days: "Jours",
    weeks: "Semaines",
    months: "Mois",
    years: "Années",
    seconds: "Secondes",
    customized: "Personnalisé",
},


adminRoles: {
  adminRoles: "Rôles administrateur",
  roleName: "Nom du rôle",
  description: "Description",
  viewPermissions: "Afficher les permissions",
  createAdminRole: "CRÉER UN RÔLE ADMINISTRATEUR",
  enterDesHere: "Entrez votre description ici",
  deleteRole: "Supprimer les rôles",
  deleteMsg: "Êtes-vous sûr de vouloir supprimer le rôle ?",
  roleReq: "Le nom du rôle est requis",
  roleLimit: "Le nom du rôle doit comporter moins de 15 caractères",
  desReq: "La description est requise",
  desLimit: "La description doit comporter 40 caractères ou moins",
  roleSuccess: "Rôle créé avec succès",
  editAdminRole: "Modifier le rôle administrateur",
  roleUpdated: "Rôle mis à jour",
  noRole: "Aucun rôle administrateur trouvé",
  noRoleMsg: "Veuillez créer un rôle administrateur en utilisant le bouton 'Créer un rôle administrateur' ci-dessus",
},

roleRequest: {
  roleRequest: "Demande de rôle",
  userRole: "Rôle utilisateur",
  approve: "Approuver",
  reject: "Rejeter",
  username: "Nom d'utilisateur",
  email: "Email",
  phone: "Téléphone",
  roleAssigned: "Rôle attribué",
  roleRequested: "Rôle demandé",
  requestedDate: "Date de la demande",
  updateRoleRequest: "Mettre à jour la demande de rôle",
  message: "Message",
  update: "Mettre à jour",
},

userslist: {
  existingUser: "Sélectionner dans les utilisateurs existants",
  addRole: "Ajouter un rôle",
  newUser: "Créer un nouvel utilisateur administrateur",
  convertUser: "Convertir en utilisateur administrateur",
  createNewUser: "Créer un nouvel utilisateur",
  chooseCreateType: "Veuillez choisir l'une des options suivantes :",
  addNewUser: "Ajouter un nouvel utilisateur",
  editUser: "Modifier l'utilisateur",
  addNewAdmin: "Ajouter un utilisateur administrateur",
  userLoading: "Chargement des utilisateurs... Veuillez patienter",
  noUser: "AUCUN UTILISATEUR DISPONIBLE",
  extendVal: "PROLONGER LA VALIDITÉ",
  extendReason: "Raison de la prolongation",
  extendReasonMsg: "Précisez la raison de la prolongation de l'adhésion",
  exportAsCSV: "EXPORTER EN CSV",
  membershipType: "Type d'adhésion",
  membershipValidity: "Validité de l'adhésion",
  regionState: "Région/État",
  cityTown: "Ville/Commune",
  clearAll: "TOUT EFFACER",
  search: "RECHERCHER",
  familyTribe: "Entrez votre tribu familiale",
  enterWebsite: "Entrez le site web",
  registrationDate: "Date d'inscription",
  single: "Simple",
  multiple: "Multiple",
  user: "Utilisateur",
  users: "Utilisateurs",
  role: "Rôle(s) utilisateur",
  department: "Département",
  registerUser: "Enregistrer l'utilisateur",
  singleUser: "Utilisateur unique",
  multipleUser: "Utilisateurs multiples",
  selectMembership: "Sélectionner l'adhésion",
  selectActivationKey: "Sélectionner la clé d'activation",
  generateKey: "Générer la clé",
  updateKey: "Mettre à jour la clé",
  deactivateUser: "Désactiver l'utilisateur",
  farmerRolePermission: "Permission de rôle pour agriculteur",
  bulkUploadUser: "Importer des utilisateurs en masse",
},


addEdituser: {
  facilityPicture: "Photo de l'établissement",
  firstNameRequired: "Le prénom est requis",
  roleNameOnlyAlpha: "Le nom du rôle ne peut contenir que des alphabets",
  roleNameLimit: "Le nom du rôle doit comporter moins de 100 caractères",
  firstNameOllyAlpha: "Le prénom ne peut contenir que des alphabets",
  firstNameLimit: "Le prénom doit comporter moins de 50 caractères",
  departmentRequired: "Le champ département est requis",
  lastNameRequired: "Le nom de famille est requis",
  lastNameOllyAlpha: "Le nom de famille ne peut contenir que des alphabets",
  lastNameLimit: "Le nom de famille doit comporter moins de 50 caractères",
  emailReuired: "L'email est requis",
  emailInvalid: "Format d'email invalide.",
  mobileRequired: "Le numéro de téléphone est requis",
  mobileLimit: "Le numéro de téléphone doit comporter moins de 15 chiffres",
  invalidMobile: "Format du numéro de téléphone invalide.",
  emailExistAlready: "Un utilisateur existe déjà avec cet email.",
  mobileExistAlready: "Un utilisateur existe déjà avec ce numéro de téléphone.",
  pswRequired: "Le mot de passe est requis",
  deptRequired: "Le département est requis",
  roleRequired: "Le rôle est requis",
  countryRequired: "Le code du pays est requis",
  userUpdated: "Utilisateur mis à jour",
  userNotUpdated: "Utilisateur non mis à jour",
  activateAct: "Activer le compte",
  deactivateAct: "Désactiver le compte",
  userActivated: "Utilisateur activé",
  userDeactivated: "Utilisateur désactivé",
  deactivateUser: "Désactiver l'utilisateur",
  deactivateMsg: "Êtes-vous sûr de vouloir changer le statut de l'utilisateur ?",
  userAdded: "Utilisateur ajouté",
  roleAdded: "Rôle ajouté",
  failedToAdd: "Échec de l'ajout",
  userNotAdded: "Utilisateur non ajouté",
  editAppUser: "Modifier l'utilisateur de l'application",
  validityUpTo: "Validité de l'adhésion jusqu'à",
  roleEdited: "Rôle modifié",
  addDepartment: "Ajouter un département",
  editDepartment: "Modifier le département",
  department: "Département",
  noDepartment: "Aucun département",
  departmentNameRequired: "Le nom du département est requis",
  departmentAdded: "Département ajouté",
  departmentEdited: "Département modifié",
  eoriNumberRequired: "Le numéro EORI est requis",
  eoriIsNumber: "Le numéro EORI doit être un chiffre",
  addNewSupplier: "Ajouter un nouveau fournisseur",
  addNewProducer: "Ajouter un nouveau producteur",
  addNewOperator: "Ajouter un nouvel opérateur",
  eoriNumber: "Numéro EORI",
},

membership: {
  remainingDays: "Nombre de jours prolongés",
  type: "Type d'adhésion",
  validity: "Validité de l'adhésion",
  validityLength: {
      custom: "Personnalisé",
      expired: "Expiré",
      oneTo8Months: "1-8 mois",
      lessThan1Month: "Moins d'1 mois",
      moreThan1Month: "Plus d'1 an",
      sixTo12Months: "6-12 mois",
  },
},

membershipplanSection: {
  noAdminMembershipsFound: "Aucun abonnement administrateur trouvé",
  pleaseAddMembership: "Veuillez ajouter un abonnement en utilisant le bouton 'Ajouter un abonnement' ci-dessus",
  defaultMembership: "Abonnement par défaut",
  areYouSureDefault: "Êtes-vous sûr de vouloir définir ce type d'abonnement par défaut ?",
  changeDefaultPlan: "Changer le plan par défaut",
  defaultPlan: "PLAN PAR DÉFAUT",
  planDuration: "Durée du plan",
  planFee: "Frais du plan",
  satelliteReport: "RAPPORT SATELLITE",
  advanceReport: "RAPPORT AVANCÉ",
  addMembership: "AJOUTER UN ABONNEMENT",
  addMembershipPlan: "Ajouter un plan d'abonnement",
  editMembershipPlan: "Modifier le plan d'abonnement",
  accessSetelite: "Accès aux rapports satellites (ensemble de 5 rapports)",
  accessAdvanceReport: "Accès aux rapports avancés",
  memPlanReq: "Le plan d'abonnement est requis",
  memPlanReqLimit: "Le plan d'abonnement doit comporter moins de 20 caractères",
  SatelliteReq: "Le rapport satellite est requis",
  advancedReportReq: "Le rapport avancé est requis",
  durationReq: "La durée de l'abonnement est requise",
  feeReq: "Les frais d'abonnement sont requis",
  cantLesThenZero: "Ne peut pas être inférieur à 0",
  roleReq: "Le rôle utilisateur est requis",
  selectPlan: "Sélectionner un plan",
  planType: "Type de plan",
  enterprise: "Entreprise",
  noOfUsersAllowed: "Nombre d'utilisateurs autorisés",
  noOfFarms: "Nombre de fermes",
  farmsAndQuantity: "Fermes et quantité",
  perUser: "Par utilisateur",
  perFarm: "Par ferme",
  accessToDeforestationReport: "Accès aux rapports de déforestation (par utilisateur)",
  satelliteReportPackage: "Forfait rapport satellite",
  basicFarmLevelReports: "Rapports de base au niveau de la ferme",
  advancedFarmLevelReports: "Rapports avancés au niveau de la ferme",
  largeAreaReports: "Rapports pour grandes zones",
},

statusItems: {
  closed: "Fermé",
  open: "Ouvert",
  moreInfoReq: "Plus d'informations requises",
},

orderByItems: {
  all: "Tous",
  dateAscending: "Date ascendante",
  dateDescending: "Date descendante",
  dueDate: "Date d'échéance",
  high: "Élevé",
  low: "Faible",
  medium: "Moyen",
},

record: {
  id: "ID",
  module: "Module",
  harvestingDate: "Date de récolte",
  noOfTrees: "Nombre d'arbres",
  reason: "Raison",
  userId: "ID utilisateur",
  appVersion: "Version de l'application",
  createdAt: "Créé le",
},


ownershipTypes: {
  EXW: "EXW (À l'usine)",
  FCA: "FCA (Franco transporteur)",
  CPT: "CPT (Port payé jusqu'à)",
  CIP: "CIP (Port payé, assurance comprise, jusqu'à)",
  DAP: "DAP (Rendu au lieu de destination)",
  DPU: "DPU (Rendu au lieu de destination déchargé)",
  DDP: "DDP (Rendu droits acquittés)",
  FAS: "FAS (Franco le long du navire)",
  FOB: "FOB (Franco à bord)",
  CFR: "CFR (Coût et fret)",
  CIF: "CIF (Coût, assurance et fret)"
},
  "Enterprises": {
    "Enterprise": "Entreprise",
    "Resgister_New_Enterprise": "Enregistrer une nouvelle entreprise",
    "Registration_Date": "Date d'enregistrement",
    "Activation_Keys": "Clés d'activation",
    "EnterpriseDetailsForm": {
      "Submit": "Soumettre",
      "Register_New_Enterprise_Client_Organization": "Enregistrer une nouvelle entreprise/client/organisation",
      "Enterprise_Client_Organization_Name": "Nom de l'entreprise/client/organisation",
      "Enterprise_Client_Organization_Logo": "Logo de l'entreprise/client/organisation",
      "Browse": "Parcourir",
      "Supported_File_Format": "format de fichier pris en charge JPG, PNG, GIF, SVG",
      "Enterprise_Client_Organization_Phone_Number": "Numéro de téléphone de l'entreprise/client/organisation",
      "Language_s": "Langue(s)",
      "Select_Language": "Sélectionner la langue",
      "Crop_Variety": "Variété de culture",
      "Select_Crop_Variety": "Sélectionner la variété de culture",
      "User_Role_s": "Rôle(s) de l'utilisateur",
      "Select_User_Role": "Sélectionner le rôle de l'utilisateur",
      "Country": "Pays",
      "Select_Country": "Sélectionner le pays",
      "Province_State": "Province / État",
      "Region_District": "Région / District",
      "Village_Town_City": "Village / Ville",
      "Address": "Adresse",
      "Status": "Statut",
      "Select_Status": "Sélectionner le statut"
    },
    "EnterpriseUsers": {
      "Enterprise_Users": "Utilisateurs de l'entreprise",
      "Users": "Utilisateurs",
      "Register_Users": "ENREGISTRER UTILISATEUR(S)",
      "Search": "Rechercher",
      "All_Countries": "Tous les pays",
      "All_Regions": "Toutes les régions",
      "All_Forms": "Tous les formulaires",
      "Page_Of": "Page {page} sur {totalPages}",
      "Activation_Key": "Clé d'activation",
      "User_Name_ID": "Nom d'utilisateur & ID",
      "Full_Name": "Nom complet",
      "Email": "Email",
      "User_Role": "Rôle de l'utilisateur",
      "User_Registration_Date": "Date d'inscription de l'utilisateur",
      "Status": "Statut",
      "Active": "Actif",
      "Inactive": "Inactif",
      "All": "Tous",
      "Active_Users": "Utilisateurs actifs",
      "Offline_Users": "Utilisateurs hors ligne",
      "Deactivated_Users": "Utilisateurs désactivés",
      "App_Users": "Utilisateurs de l'application",
      "Admin_Users": "Utilisateurs administrateurs"
    },
    "AdminUsersForm": {
      "Admin_User": "Utilisateur administrateur",
      "Name": "Nom",
      "Email": "Email",
      "Add_More": "Ajouter plus",
      "Remove": "Supprimer"
    },
    "AdminEnvironmentDialog": {
      "Create_Admin_Environment": "Créer un environnement administrateur",
      "Creating_Admin_Environment": "Création de l'environnement administrateur",
      "Please_Wait": "Veuillez patienter",
      "Cancel": "ANNULER"
    },
    "ProfileInfo": {
      "Crop_Variety": "Variété de culture",
      "Membership_Plan": "Plan d'adhésion",
      "Advanced": "Avancé"
    },
    "ModuleAccess": {
      "Access_to_Modules_on_Admin_Panel": "Accès aux modules sur le panneau d'administration",
      "Dashboard": "Tableau de bord",
      "Coffee_Overview": "Aperçu du café",
      "Farm_Management": "Gestion de la ferme",
      "Survey_Builder": "Constructeur de sondage",
      "Deforestation": "Déforestation",
      "User_Management": "Gestion des utilisateurs",
      "FAQ": "Questions fréquemment posées (FAQ)",
      "Tickets": "Tickets",
      "Activity_Log": "Journal d'activité",
      "Settings": "Paramètres",
      "Member_Data": "Données des membres",
      "Admin_Roles": "Rôles administratifs"
    },
    "BillingSummary": {
      "Billing_Summary": "Résumé de la facturation",
      "Update_Payment_Info": "Mettez à jour vos informations de paiement ou changez de plan selon vos besoins.",
      "Base_Plan_Package": "Forfait de base",
      "Total_Paid": "Total payé",
      "To_Be_Paid": "À payer",
      "Manage_Plan": "GÉRER LE PLAN",
      "Extra_Usage": "Utilisation supplémentaire",
      "Change_Billing_Period": "CHANGER LA PÉRIODE DE FACTURATION",
      "Total_Amount_Due": "Montant total dû",
      "Billing_History": "Historique de facturation",
      "Search": "Rechercher",
      "Transaction_ID": "ID de transaction",
      "Admin_User": "Utilisateur administrateur",
      "Amount": "Montant",
      "Mode_of_Payment": "Mode de paiement",
      "Transaction_Date": "Date de transaction",
      "Receipt": "Reçu",
      "Status": "Statut",
      "Paid": "Payé",
      "Unpaid": "Non payé",
      "View": "Voir"
    },
    "ListingEnterprises": {
      "Search": "Rechercher",
      "Export_As_CSV": "Exporter en CSV",
      "Records_Selected": "enregistrements sélectionnés",
      "Create_Admin_Environment": "CRÉER UN ENVIRONNEMENT ADMINISTRATEUR",
      "Deactivate": "DÉSACTIVER",
      "Enterprise": "Entreprise",
      "Registration_Date": "Date d'enregistrement",
      "Activation_Keys": "Clés d'activation",
      "Status": "Statut",
      "Actions": "Actions",
      "View": "Voir",
      "Edit": "Modifier",
      "Request_Extra_Reports": "Demander des rapports supplémentaires",
      "Create_Admin_Environment_Action": "Créer un environnement administrateur",
      "Deactivate_Action": "Désactiver"
    }
  }


}